<script>
  import { afterUpdate } from 'svelte';
  import Highcharts from 'highcharts';

  export let data;
  export let highchartboxwidth = '100%';
  export let highchartboxheight = '300px';

  let canvas;

  afterUpdate(() => {
    setTimeout(() => {
      Highcharts.chart(canvas, data);
    }, 50);
  });
</script>

<div
  bind:this={canvas}
  style="--chart-height: {highchartboxheight}; --chart-width: {highchartboxwidth}"
>
  <slot />
</div>

<style>
  div {
    display: flex;
    align-items: center;
    height: var(--chart-height, auto);
    width: var(--chart-width, auto);
  }

  :global(.highcharts-root) {
    font-family: inherit !important;
  }

  :global(.highcharts-tooltip-box) {
    fill: black !important;
    stroke-width: 0;
    border-radius: 4px;
  }

  :global(.highcharts-tooltip text) {
    fill: white !important;
    font-size: 10px;
    line-height: 12px;
    font-weight: bold;
  }

  :global(.highcharts-credits) {
    display: none;
  }
</style>
